import React from "react";

const Footer = () => {
  return (
    <footer className="bg-black text-white px-4 md:px-8" style={{ paddingTop: 'clamp(32px, 6vw, 52.8px)', paddingBottom: 'clamp(32px, 6vw, 52.8px)' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div>
          <p 
            className="text-white font-normal"
            style={{
              fontSize: 'clamp(14px, 3vw, 17.6px)',
              lineHeight: 'clamp(24px, 5vw, 33.44px)',
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              fontWeight: 400,
              marginBottom: '0',
              marginTop: '0'
            }}
          >
            emdash GmbH
          </p>
          <p 
            className="text-white font-normal"
            style={{
              fontSize: 'clamp(14px, 3vw, 17.6px)',
              lineHeight: 'clamp(24px, 5vw, 33.44px)',
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              fontWeight: 400,
              marginBottom: '0',
              marginTop: '0'
            }}
          >
            Maiengasse 58
          </p>
          <p 
            className="text-white font-normal"
            style={{
              fontSize: 'clamp(14px, 3vw, 17.6px)',
              lineHeight: 'clamp(24px, 5vw, 33.44px)',
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              fontWeight: 400,
              marginBottom: '0',
              marginTop: '0'
            }}
          >
            4056 Basel
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;